import { render, staticRenderFns } from "./listarCadeiras.vue?vue&type=template&id=8bcdc684&"
import script from "./listarCadeiras.vue?vue&type=script&lang=js&"
export * from "./listarCadeiras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports